import { render, staticRenderFns } from "./comments.vue?vue&type=template&id=69f5df0c&scoped=true"
import script from "./comments.vue?vue&type=script&lang=js"
export * from "./comments.vue?vue&type=script&lang=js"
import style0 from "./comments.vue?vue&type=style&index=0&id=69f5df0c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f5df0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69f5df0c')) {
      api.createRecord('69f5df0c', component.options)
    } else {
      api.reload('69f5df0c', component.options)
    }
    module.hot.accept("./comments.vue?vue&type=template&id=69f5df0c&scoped=true", function () {
      api.rerender('69f5df0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/comments.vue"
export default component.exports